(function ($) {$(function(){
    landscapePreviewVideo();
    setInterval(window.landscapePreviewVideo, 10)
    // landscapePreviewVideo();
});}(_jQ3));

_jQ3(window).resize(window.landscapePreviewVideo);

window.landscapePreviewVideo = function(){
    const $ = _jQ3;
    const $video = $('video.active');
    if ($video.length > 0) {

        $video.each(function(){
            const $this = $(this);
            const w = $this.outerWidth(true);
            const h = $this.outerHeight(true);
            const containerW = $this.parent().width();
            const containerH = $this.parent().height();
            if (containerW > w) {
                $this.parent().addClass('landscape');
            } 
            if (containerH > h) {
                $this.parent().removeClass('landscape');
            }

        });
        // if (!$('body').hasClass('page-template-PostLanding')) {
        // }
    }
}